import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';

const formatDate = (inputDate: string) => {
  const [day, month, year] = inputDate.split('/').map(Number);
  const date = new Date(year, month - 1, day); // Subtract 1 from the month since it's 0-based

  // Format the date using date-fns
  return format(date, "do MMMM yyyy");
};

const DateTimeDisplay = () => {
  const today = new Date();
  const inputDate = `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`;
  const formattedDate = formatDate(inputDate);
 
  const [currentTime, setCurrentTime] = useState("");
 
  useEffect(() => {
   const intervalId = setInterval(() => {
    const now = new Date();
    const ukTime = now.toLocaleTimeString('en-GB', {
     hour: '2-digit',
     minute: '2-digit',
     second: '2-digit',
     hour12: true, // Use 12-hour time format
    });
    setCurrentTime(ukTime);
   }, 1000);
 
   return () => {
    clearInterval(intervalId);
   };
  }, []);
 
  return (
   <div className='date-time'>
    <p>
     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
      <path d="M789 186c59 0 107 48 107 107v489c0 59-48 107-107 107H235c-59 0-107-48-107-107V293c0-59 48-107 107-107h115v-29c0-12 9-22 21-22s22 10 22 22v29h238v-29c0-12 10-22 22-22s21 10 21 22v29h115zm-554 43c-36 0-64 28-64 64v61h682v-61c0-36-28-64-64-64H674v33c0 12-9 21-21 21s-22-9-22-21v-33H393v33c0 12-10 21-22 21s-21-9-21-21v-33H235zm554 617c36 0 64-29 64-64V397H171v385c0 35 28 64 64 64h554z"/>
     </svg>
     {formattedDate}, {currentTime}
    </p>
   </div>
  );
 };
 
 export default DateTimeDisplay;